import { gql } from '@apollo/client';

export const REPLY_TO_POST_AS_DRAFT_MUTATION = gql`
    mutation replyToPostAsDraft($input: ReplyToPostAsDraftInput) {
        replyToPostAsDraft(input: $input) {
            id
            parentPostId
            status
            categories
            textBlocks {
                id
                type
                data {
                    paragraph
                    header
                    level
                    items {
                        id
                        text
                    }
                    file {
                        url
                    }
                    code
                    withBorder
                    withBackground
                    stretched
                    caption
                    style
                }
            }
            textBlocksVersions {
                blocks {
                    id
                    type
                    data {
                        paragraph
                        header
                        level
                        items {
                            id
                            text
                        }
                        file {
                            url
                        }
                        code
                        withBorder
                        withBackground
                        stretched
                        caption
                        style
                    }
                }
                id
            }
            createdAt
            updatedAt
        }
    }
`;
